<template>
<div class="vx-col md:w-full w-full mb-base">
    <vx-card title="Lista de periodos" v-if="modalPeriodos">
        <vs-button type="border" color="primary" class="m-2" @click="cerrarModal()">← Regresar</vs-button>
        <vs-table max-items="10" search pagination :data="listaPeriodos">
            <template slot="header">
                <vs-radio class="mb-3 m-2" color="success" v-model="f_periodos" @change="filtroPeriodos" vs-value="1">Activos</vs-radio>
                <vs-radio class="mb-3 m-2" color="danger" v-model="f_periodos" @change="filtroPeriodos" vs-value="0">Inactivos</vs-radio>
            </template>
            <template slot="thead">
                <vs-th>Periodo escolar</vs-th>
                <vs-th>Fechas</vs-th>
                <vs-th>Region</vs-th>
                <vs-th>Estado</vs-th>
                <vs-th>Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="tr.periodoescolar">
                        {{tr.periodoescolar}} <br>
                        <small>{{tr.descripcion}}</small>
                    </vs-td>
                    <vs-td>
                        <small>Inicio: {{tr.fecha_inicial}} </small><br>
                        <small>Fin: {{tr.fecha_final}}</small>
                    </vs-td>
                    <vs-td>
                        <vs-chip v-if="tr.region_idregion == 1"> SIERRA</vs-chip>
                        <vs-chip v-if="tr.region_idregion == 2"> COSTA</vs-chip>
                    </vs-td>
                    <vs-td>
                        <vs-chip v-if="tr.estado == 1" color="success"> Activo</vs-chip>
                        <vs-chip v-if="tr.estado == 0" color="danger"> Inactivo</vs-chip>
                    </vs-td>
                    <vs-td>
                        <vs-button type="filled" size="small" color="success" class="m-2" icon-pack="feather" icon="icon-plus" @click="verificarPeriodo(tr);">Agregar</vs-button>

                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </vx-card>
    <vx-card :title="'Institución: ' + nombreInstitucion" v-if="verCardInstitucion">
        <div class="flex">
            <vs-button type="border" color="success" class="m-2" @click="abrirModal();">Agregar periodo</vs-button>
        </div>
        <vs-table max-items="20" search pagination :data="listaPeriodosInstitucion" class="mt-4">
            <template slot="header">
                <div>
                    Cantidad: {{listaPeriodosInstitucion.length}}
                </div>
            </template>
            <template slot="thead">
                <vs-th width="40%">Periodo escolar</vs-th>
                <vs-th>Región</vs-th>
                <vs-th>Estado</vs-th>
                <vs-th>Actualizado</vs-th>
                <vs-th>Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="tr.periodoescolar">
                        {{tr.periodoescolar}} <br>
                        <small> {{tr.descripcion}} </small>
                    </vs-td>
                    <vs-td>
                        <vs-chip> {{tr.nombreregion}}</vs-chip>
                    </vs-td>
                    <vs-td>
                        <vs-chip v-if="tr.estado == 1" color="success"> Activo</vs-chip>
                        <vs-chip v-if="tr.estado == 0" color="danger"> Inactivo</vs-chip>
                    </vs-td>
                    <vs-td>
                        {{tr.updated_at}}
                    </vs-td>
                    <vs-td>
                        <vx-tooltip text="eliminar periodo de esta institución" position="top" color="danger">
                            <vs-button type="border" color="danger" class="m-2" icon-pack="feather" icon="icon-trash" @click="confirmaEliminar(tr);"></vs-button>
                        </vx-tooltip>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </vx-card>
    <vx-card v-if="modalConfirmaEliminar" class="text-center">
        <h3>
            ¿Esta seguro en eliminar este registro?
        </h3>
        <p>
            <vs-button class="m-3" color="success" @click="eliminarItem()">Aceptar</vs-button>
            <vs-button class="m-3" color="danger" @click="f_cancelar()">Cancelar</vs-button>
        </p>
    </vx-card>

</div>
</template>

<script>
export default {
    name: "PeriodosInstitucion",
    components: {},
    data() {
        return {
            nombreInstitucion: '',
            idInstitucion: '',
            listaPeriodos: '',
            tmplistaPeriodos: '',
            listaPeriodosInstitucion: '',
            tmp: '',
            f_periodos: 1,
            modalPeriodos: false,
            id_eliminar: '',
            region: '',
            modalConfirmaEliminar: false,
            verCardInstitucion: true,
        }
    },
    mounted() {
        let me = this;
        me.tmp = JSON.parse(localStorage.getItem('institucion'));
        me.nombreInstitucion = me.tmp.nombreInstitucion;
        me.idInstitucion = me.tmp.idinstitucion;
        me.region = me.tmp.region;
        me.getPeriodosInstitucion();
        me.getPeriodos();
    },
    methods: {
        getPeriodosInstitucion() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'periodosXInstitucion/' + me.idInstitucion)
                .then(res => {
                    me.listaPeriodosInstitucion = res.data;
                    // console.log(res.data);
                    me.$vs.loading.close();
                })
                .catch(err => {
                    console.log(err);
                    me.$vs.loading.close();
                })
        },
        getPeriodos() {
            let me = this;
            me.$http.get(this.$server_url + 'periodos?buscaregion=' + me.region)
                .then(res => {
                    me.tmplistaPeriodos = res.data;
                    me.filtroPeriodos();
                })
                .catch(err => {
                    console.log(err);
                })
        },
        abrirModal() {
            let me = this;
            me.modalPeriodos = true;
            me.verCardInstitucion = false;
        },
        cerrarModal() {
            let me = this;
            me.modalPeriodos = false;
            me.verCardInstitucion = true;
        },
        filtroPeriodos() {
            let me = this;
            // console.log(me.tmplistaPeriodos)
            me.listaPeriodos = [];
            for (let index = 0; index < me.tmplistaPeriodos.length; index++) {
                if (me.tmplistaPeriodos[index].estado == me.f_periodos) {
                    me.listaPeriodos.push(me.tmplistaPeriodos[index]);
                }
            }
        },
        verificarPeriodo(item) {
            let me = this;
            // console.log(item.idperiodoescolar, me.idInstitucion)
            me.$vs.loading();
            let data = new FormData();
            data.append('idperiodoescolar', item.idperiodoescolar);
            data.append('idInstitucion', me.idInstitucion)
            me.$http.post(this.$server_url + 'verifica_periodo', data)
                .then(res => {
                    if (res.data == 1) {
                        me.$vs.notify({
                            time: 8000,
                            text: 'Este periodo ya se encuentra asignado a la institucion ' + me.nombreInstitucion,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        })
                    } else {
                        me.$vs.notify({
                            text: 'Periodo agregado correctamente a la institucion ' + me.nombreInstitucion,
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        })
                        me.modalPeriodos = false;
                        me.verCardInstitucion = false;
                        me.getPeriodosInstitucion();
                        me.$emit('changePeriodo',true);
                    }
                    me.$vs.loading.close();
                })
                .catch(err => {
                    console.log(err);
                    me.$vs.loading.close();
                })
        },
        confirmaEliminar(item) {
            let me = this;
            me.id_eliminar = item.id;
            me.modalConfirmaEliminar = true;
            me.verCardInstitucion = false;
        },
        eliminarItem() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'eliminarPeriodosInstitucion/' + me.id_eliminar)
                .then(() => {
                    me.$vs.notify({
                        text: 'Periodo de esta institución eliminado correctamente',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                    me.getPeriodosInstitucion();
                    me.modalConfirmaEliminar = false;
                    me.verCardInstitucion = true;
                    me.$emit('quitarPeriodo',true);
                    me.$vs.loading.close();
                })
                .catch(err => {
                    console.log(err);
                    me.$vs.loading.close();
                })
        },
        f_cancelar(){
            let me = this;
            me.modalConfirmaEliminar = false;
            me.verCardInstitucion = true;
        }
    }
}
</script>
